// extracted by mini-css-extract-plugin
export default {"bottomAd_box":"index_bottomAd_box_wTAlt","bottomAd":"index_bottomAd_cqLwQ"};